import { SUGGEST_NEW_BONUS_URL } from "../../../../../constants/commonUrls";

function goToSuggestBonusPage() {
  window.open(SUGGEST_NEW_BONUS_URL, "_blank", "noopener noreferrer");
}

export default goToSuggestBonusPage;
